<template>
    <SocialAuthBtn
        :img="LinkedInLogo"
        :label="$t('shared.loginModule.socialAuthBtns.continueWithLinkedIn')"
        color="#0077b5"
        class="linkedin-btn"
        :tiny="tiny"
        @click="lLogIn"
    />
</template>

<script>
import SocialAuthBtn from './SocialAuthBtn';
import LinkedInFlow from '~/utils/socialAuth/LinkedInFlow';

// Assets
import LinkedInLogo from '~/assets/img/LinkedIn.png';

export default {
    name: 'LinkedInLoginBtn',
    components: { SocialAuthBtn },
    data: () => ({
        LinkedInLogo,
    }),
    props: {
        redirectPath: String,
        tiny: Boolean,
    },
    methods: {
        setLoading(value) {
            this.$emit('input', value);
        },
        async lLogIn() {
            let queryObject = {
                redirectUrl: this.$interfaces.logInModule.getRedirect() || this.$route.path,
            };
            LinkedInFlow.startAuthFlow(this.redirectPath, queryObject, this.$route.query || {});
        },
    },
};
</script>

<style>
.linkedin-btn > img {
    /* margin: -4px 30px 4px 0 !important; */
    width: 24px !important;
    height: 24px !important;
}
</style>
